import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AccessRequestPage from './pages/AccessRequestPage';
import MaintenancePage from './pages/MaintenancePage';
import AdminPortalPage from './pages/AdminPortalPage';
import AddUserAddressPage from './pages/AddUserAddress';
import RenewIpPage from './pages/RenewIpPage';
import ChangelogPage from './pages/ChangelogPage';
import DownloadPage from './pages/DownloadPage';
import PasswordResetPage from './pages/PasswordResetPage';
import './App.css';
import UnapprovedPage from './pages/UnapprovedPage';
import InstallPackagesPage from './pages/InstallPackagesPage';
import LoginPage from './pages/LoginPage';
import ImportPage from './pages/ImportPage';

const App = () => {
  // Detect path prefix from URL (e.g., /overleaf when proxied from iis.memphis.edu/overleaf/)
  const pathPrefix = window.location.pathname.match(/^\/[^/]+/) ? window.location.pathname.match(/^\/[^/]+/)[0].replace(/\/$/, '') : '';

  return (
    <Router basename={pathPrefix}>
      <div className="App">
        <Routes>
          <Route path="/access-request" element={<AccessRequestPage />} />
          <Route path="/access-request/" element={<AccessRequestPage />} />
          <Route path="/access-request/*" element={<AccessRequestPage />} />
          <Route path="/temp-password" element={<PasswordResetPage />} />
          <Route path="/temp-password/" element={<PasswordResetPage />} />
          <Route path="/temp-password/*" element={<PasswordResetPage />} />
          <Route path="/portal-admin" element={<AdminPortalPage />} />
          <Route path="/portal-admin/" element={<AdminPortalPage />} />
          <Route path="/portal-admin/*" element={<AdminPortalPage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="/maintenance/" element={<MaintenancePage />} />
          <Route path="/maintenance/*" element={<MaintenancePage />} />
          <Route path="/unapproved" element={<UnapprovedPage />} />
          <Route path="/unapproved/" element={<UnapprovedPage />} />
          <Route path="/unapproved/*" element={<UnapprovedPage />} />
          <Route path="/add-user-address" element={<AddUserAddressPage />} />
          <Route path="/add-user-address/" element={<AddUserAddressPage />} />
          <Route path="/add-user-address/*" element={<AddUserAddressPage />} />
          <Route path="/renew-ip" element={<RenewIpPage />} />
          <Route path="/renew-ip/" element={<RenewIpPage />} />
          <Route path="/renew-ip/*" element={<RenewIpPage />} />
          <Route path="/install-packages" element={<InstallPackagesPage />} />
          <Route path="/install-packages/" element={<InstallPackagesPage />} />
          <Route path="/install-packages/*" element={<InstallPackagesPage />} />
          <Route path="/changelog" element={<ChangelogPage />} />
          <Route path="/changelog/" element={<ChangelogPage />} />
          <Route path="/changelog/*" element={<ChangelogPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/download/" element={<DownloadPage />} />
          <Route path="/download/*" element={<DownloadPage />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/import/" element={<ImportPage />} />
          <Route path="/import/*" element={<ImportPage />} />
          <Route path="/custom-login" element={<LoginPage />} />
          <Route path="/custom-login/" element={<LoginPage />} />
          <Route path="/custom-login/*" element={<LoginPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
